import axios from 'axios'

const state = {
  pageNr: 1,
  statusUpdates: [],
}

const getters = {
  getPageNr(state) {
    return state.pageNr
  },
  getStatusUpdates(state) {
    return state.statusUpdates
  },
}

const mutations = {
  SET_PAGENR(state, newValue) {
    state.pageNr = newValue
  },
  SET_STATUS_UPDATES(state, newValue) {
    if (state.pageNr === 1) {
      state.statusUpdates = newValue
    } else {
      state.statusUpdates = state.statusUpdates.concat(newValue)
    }
  },
  UPDATE_STATUS_UPDATE(state, newValue) {
    state.statusUpdates = state.statusUpdates.map((item) => {
      if (item.id === newValue.id) {
        return { ...item, ...newValue }
      }
      return item
    })
  },
  ADD_STATUS_UPDATE(state, newValue) {
    state.statusUpdates = [newValue].concat(state.statusUpdates)
  },
  ADD_LIKE_STATUS_UPDATE(state, params) {
    const statusUpdate = getStatusUpdateById(state, params.statusUpdateId)
    if (!statusUpdate) {
      return
    }

    const like = {
      status_update_id: params.statusUpdateId,
      user_id: params.user_id,
    }

    statusUpdate.post_likes.push(like)
    statusUpdate.is_likeable = false
  },
  ADD_COMMENT_STATUS_UPDATE(state, newComment) {
    const statusUpdate = getStatusUpdateById(state, newComment.status_update_id)
    statusUpdate && statusUpdate.comments.push(newComment)
  },
  ADD_LIKE_COMMENT(state, params) {
    const statusUpdate = getStatusUpdateById(state, params.statusUpdateId)
    if (!statusUpdate) {
      return
    }
    const comment = statusUpdate.comments.find(
      (comment) => comment.id === params.commentId
    )
    if (!comment) {
      return
    }

    const like = {
      id: 0,
      comment_id: comment.id,
      user_id: params.user_id,
    }
    comment.comment_likes.push(like)
    comment.is_likeable = false
  },
  UPDATE_COMPANY_BACKGROUND(state, newValue) {
    const company = getCompanyById(newValue.rootState, newValue.companyId)
    company.background_url = newValue.backgroundUrl
  },
  UPDATE_GROUP_BACKGROUND(state, newValue) {
    const company = getCompanyById(newValue.rootState, newValue.companyId)
    const group = getGroupById(company.groups, newValue.groupId)
    group.background_url = newValue.backgroundUrl
  },
}

const actions = {
  fetchStatusUpdates({ commit, dispatch, getters }, { companyId, pageNr }) {
    if (pageNr) commit('SET_PAGENR', pageNr)
    return axios
      .get(`/api/v1/company/${companyId}/status_updates/${getters.getPageNr}`)
      .then((response) => {
        commit('SET_STATUS_UPDATES', response.data)
        commit('SET_PAGENR', getters.getPageNr + 1)
        return response.data
      })
  },
  fetchStatusUpdatesGroup({ commit, dispatch, getters }, { groupId, pageNr }) {
    if (pageNr) commit('SET_PAGENR', pageNr)
    return axios
      .get(`/api/v1/group/${groupId}/status_updates/${getters.getPageNr}`)
      .then((response) => {
        commit('SET_STATUS_UPDATES', response.data)
        commit('SET_PAGENR', getters.getPageNr + 1)
        return response.data
      })
  },
  postNewComment(
    { commit, dispatch, getters },
    { content, statusUpdateId, userId }
  ) {
    return axios
      .post(`/api/v1/comment`, {
        content: content,
        status: 'approved',
        status_update_id: statusUpdateId,
        user_id: userId,
      })
      .then((response) => {
        commit('ADD_COMMENT_STATUS_UPDATE', response.data)
        return response.data
      })
  },
  likeComment(
    { commit, dispatch, getters },
    { statusUpdateId, commentId, userId }
  ) {
    return axios
      .post(`/api/v1/comments/add_like`, {
        commentId: commentId,
      })
      .then((response) => {
        commit('ADD_LIKE_COMMENT', {
          statusUpdateId: statusUpdateId,
          commentId: commentId,
          userId: userId,
        })
        return response.data
      })
  },
  likePost({ commit, dispatch, getters }, { statusUpdateId, userId }) {
    return axios
      .post(`/api/v1/status_updates/add_like`, {
        statusUpdateId: statusUpdateId,
      })
      .then((response) => {
        commit('ADD_LIKE_STATUS_UPDATE', {
          statusUpdateId: statusUpdateId,
          userId: userId,
        })
        return response.data
      })
  },
  postNewStatusUpdate(
    { commit, dispatch, getters },
    {
      text,
      hours,
      kyndCode,
      amount,
      type,
      kyndnessType,
      userId,
      updatableId,
      updatableType,
      postAnonymous,
      challenge,
      giver,
      organization,
      causes,
      friends,
      tags,
      images,
      videoUrl,
      opportunityId,
    }
  ) {
    return axios
      .post(`/api/v1/status_update`, {
        text: text,
        type: type,
        hours: hours,
        kynd_code: kyndCode,
        amount: amount,
        kyndness_type: kyndnessType,
        user_id: userId,
        updatable_id: updatableId,
        updatable_type: updatableType,
        post_anonymous: postAnonymous,
        challenge: JSON.stringify(challenge),
        giver: JSON.stringify(giver),
        charity_organization: JSON.stringify(organization),
        charity_organization_id: organization ? organization.id : 0,
        causes: JSON.stringify(causes),
        friends: JSON.stringify(friends),
        tags: JSON.stringify(tags),
        images: JSON.stringify(images),
        video_url: JSON.stringify(videoUrl),
        opportunity_id: opportunityId,
      })
      .then((response) => {
        commit('ADD_STATUS_UPDATE', response.data)
        return response.data
      })
  },
  saveStatusUpdate({ commit, dispatch, getters }, { post }) {
    return axios
      .post(`/api/v1/status_update/${post.id}`, post)
      .then((response) => {
        commit('UPDATE_STATUS_UPDATE', response.data)
        return response.data
      })
  },
  fetchFriends({ commit, dispatch }, { startingWith }) {
    return axios
      .get(`/api/v1/friends/startingWith/${startingWith}`)
      .then((response) => {
        return response
      })
  },
  fetchOrganizations({ commit, dispatch }, { startingWith }) {
    return axios
      .get(`/api/v1/charity-organization/startingWith/${startingWith}`)
      .then((response) => {
        return response
      })
  },
  fetchCauses({ commit, dispatch }) {
    return axios.get(`/api/v1/causes`).then((response) => {
      return response
    })
  },
  fetchTags({ commit, dispatch }, { startingWith }) {
    return axios
      .get(`/api/v1/tags/startingWith/${startingWith}`)
      .then((response) => {
        return response
      })
  },
  changeStatus({ commit, dispatch, getters }, { statusUpdateId, status }) {
    return axios
      .post(`/api/v1/status_update/change_status`, {
        status: status,
        status_update_id: statusUpdateId,
      })
      .then((response) => {
        commit('UPDATE_STATUS_UPDATE', response.data)
        return response.data
      })
  },
  updateBG({ commit, state, rootState }, { companyId, backgroundUrl }) {
    return axios
      .post(
        `/api/v1/company/${companyId}/update_background_image
      `,
        {
          background_url: backgroundUrl,
        }
      )
      .then((response) => {
        commit('UPDATE_COMPANY_BACKGROUND', {
          rootState: rootState,
          companyId: companyId,
          backgroundUrl: response.data,
        })
        return response.data
      })
  },
  updateGroupBG(
    { commit, state, rootState },
    { companyId, groupId, backgroundUrl }
  ) {
    return axios
      .post(
        `/api/v1/group/${groupId}/update_background_image
      `,
        {
          background_url: backgroundUrl,
        }
      )
      .then((response) => {
        commit('UPDATE_GROUP_BACKGROUND', {
          rootState: rootState,
          companyId: companyId,
          groupId: groupId,
          backgroundUrl: response.data,
        })
        return response.data
      })
  },
  acceptHubInvite({ commit, dispatch, getters }, { requestId }) {
    return axios
      .post(`/api/v1/company/acceptHubInvite`, {
        requestId: requestId,
      })
      .then((response) => {
        return response.data
      })
  },
  rejectHubInvite({ commit, dispatch, getters }, { requestId }) {
    return axios
      .post(`/api/v1/company/rejectHubInvite`, {
        requestId: requestId,
      })
      .then((response) => {
        return response.data
      })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}

function getStatusUpdateById(state, id) {
  return state.statusUpdates.find((statusUpdate) => statusUpdate.id === id)
}

function getCompanyById(rootState, id) {
  return rootState.auth.currentUser.companies.find(
    (company) => company.id === id
  )
}

function getGroupById(groups, id) {
  return groups.find((group) => group.id === id)
}
